module.exports = __webpack_public_path__ + "static/media/gary.e25973f1.jpg";